module.exports = __webpack_public_path__ + "static/media/bmg_logo.28dbe276.svg";